import React from 'react';
import { useDispatch } from "react-redux";
import { Modal, Button, Alert, FormInput } from "components/common";
import { closeRequestTerminalAccount } from "redux/request/terminalAccountSlice";
import { toast } from "react-toastify";
import { FaCheckCircle } from "react-icons/fa";
import PropTypes from 'prop-types';
import { useForm } from "react-hook-form";

const CloseRequestTerminalAccountConfirm = ({ open, setOpen, record }) => {
  const { register, handleSubmit } = useForm();

  const dispatch = useDispatch();

  const closeModal = () => {
    setOpen(false);
  };

  const onSubmit = async (data) => {
    try {
      await dispatch(closeRequestTerminalAccount({ recordId: record.id, data })).unwrap();
      closeModal();
    }
    catch (error) {
      toast.error(error.message);
    }
  };

  return (
    <Modal
      show={open}
      onHide={closeModal}
      title="Close request terminal account!"
      backdropClick={false}
      footer={(
        <div className="tw-flex tw-justify-center tw-gap-2 tw-w-full">
          <Button type="submit" variant="primary" className="tw-px-4" form="close-request-terminal-account-form">
            <FaCheckCircle className="tw-mr-2" /> Yes, Close
          </Button>
          <Button variant="ghost" onClick={closeModal} className="tw-px-4">
            Cancel
          </Button>
        </div>
      )}
    >
      <form id="close-request-terminal-account-form" onSubmit={handleSubmit(onSubmit)}>
        <Alert type="warning" className="tw-mb-4">
          Are you sure you want to <strong>close</strong> the request terminal account for <strong>{record.email}</strong>?
        </Alert>

        <FormInput
          label="Remark"
          type="textarea"
          rows={10}
          placeholder="Give some comments."
          {...register("remark")}
        />
      </form>
    </Modal>
  );
};

CloseRequestTerminalAccountConfirm.propTypes = {
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
  record: PropTypes.object.isRequired
};

export default CloseRequestTerminalAccountConfirm;
